import React from 'react'
import { StyledDivision, StyledPlanogramLinks } from '../styles'
import { openPdf } from '../../../services/postingsUpdatesService'

const PlanogramLink = ({ planograms, planogramFormat, countryCode }) => {
  const canadaPlanogram = planograms.find((planogram) => planogram.name === 'Canada')
  const englishAOOPlanogram = planograms.find((planogram) => planogram.name === 'All on One English')
  const spanishAOOPlanogram = planograms.find((planogram) => planogram.name === 'All on One Spanish')
  const englishCombinedPlanogram = planograms.find((planogram) => planogram.name === 'Combined English')
  const spanishCombinedPlanogram = planograms.find((planogram) => planogram.name === 'Combined Spanish')
  const amazonPlanogram = planograms.find((planogram) => planogram.name === 'Amazon Combined')

  if (canadaPlanogram && countryCode === 'CA') {
    return (
      <StyledPlanogramLinks
        onClick={() => openPdf(canadaPlanogram.s3BucketName, canadaPlanogram.s3Key, canadaPlanogram.region)}
      >{canadaPlanogram.language}
      </StyledPlanogramLinks>
    )
  }

  if (amazonPlanogram && planogramFormat === 'Amazon') {
    return (
      <StyledPlanogramLinks
        onClick={() => openPdf(amazonPlanogram.s3BucketName, amazonPlanogram.s3Key, amazonPlanogram.region)}
      >{amazonPlanogram.language}
      </StyledPlanogramLinks>
    )
  }

  if (englishAOOPlanogram && spanishAOOPlanogram && countryCode === 'US' && planogramFormat === 'AOO') {
    return (
      <span>
        <StyledPlanogramLinks
          onClick={() => openPdf(englishAOOPlanogram.s3BucketName, englishAOOPlanogram.s3Key, englishAOOPlanogram.region)}
        >{englishAOOPlanogram.language}
        </StyledPlanogramLinks>
        <StyledDivision />
        <StyledPlanogramLinks
          onClick={() => openPdf(spanishAOOPlanogram.s3BucketName, spanishAOOPlanogram.s3Key, spanishAOOPlanogram.region)}
        >{spanishAOOPlanogram.language}
        </StyledPlanogramLinks>
      </span>
    )
  }

  if (englishCombinedPlanogram && spanishCombinedPlanogram && countryCode === 'US' && planogramFormat === 'Combined') {
    return (
      <span>
        <StyledPlanogramLinks
          onClick={() => openPdf(englishCombinedPlanogram.s3BucketName, englishCombinedPlanogram.s3Key, englishCombinedPlanogram.region)}
        >{englishCombinedPlanogram.language}
        </StyledPlanogramLinks>
        <StyledDivision />
        <StyledPlanogramLinks
          onClick={() => openPdf(spanishCombinedPlanogram.s3BucketName, spanishCombinedPlanogram.s3Key, spanishCombinedPlanogram.region)}
        >{spanishCombinedPlanogram.language}
        </StyledPlanogramLinks>
      </span>
    )
  }

  if (englishAOOPlanogram && spanishCombinedPlanogram && countryCode === 'US' && planogramFormat === 'AOO English/Combined Spanish') {
    return (
      <span>
        <StyledPlanogramLinks
          onClick={() => openPdf(englishAOOPlanogram.s3BucketName, englishAOOPlanogram.s3Key, englishAOOPlanogram.region)}
        >{englishAOOPlanogram.language}
        </StyledPlanogramLinks>
        <StyledDivision />
        <StyledPlanogramLinks
          onClick={() => openPdf(spanishCombinedPlanogram.s3BucketName, spanishCombinedPlanogram.s3Key, spanishCombinedPlanogram.region)}
        >{spanishCombinedPlanogram.language}
        </StyledPlanogramLinks>
      </span>
    )
  }

  if (spanishAOOPlanogram && englishCombinedPlanogram && countryCode === 'US' && planogramFormat === 'AOO Spanish/Combined English') {
    return (
      <div>
        <StyledPlanogramLinks
          onClick={() => openPdf(englishCombinedPlanogram.s3BucketName, englishCombinedPlanogram.s3Key, englishCombinedPlanogram.region)}
        >{englishCombinedPlanogram.language}
        </StyledPlanogramLinks>
        <StyledDivision />
        <StyledPlanogramLinks
          onClick={() => openPdf(spanishAOOPlanogram.s3BucketName, spanishAOOPlanogram.s3Key, spanishAOOPlanogram.region)}
        >{spanishAOOPlanogram.language}
        </StyledPlanogramLinks>
      </div>
    )
  }

  return false
}

export default PlanogramLink
